// import router from "../../router";
//import eventBus from "../../../main";
//import jwtDecode from "jwt-decode";

import eventBus from "../../../../main";
import apiServices from "../../../../../services/apiServices";
import jwtDecode from "jwt-decode";

export default {
  state: {
    oldPWDENT: null
  },
  mutations: {
    SET_OLD_ENT_PWD(state, value) {
      state.oldPWDENT = value;
    }
  },
  actions: {
    setOldPwd(context, value) {
      context.commit("SET_OLD_ENT_PWD", value);
    },
    createNewPwdEnterprise(context, payload) {
      if (context.getters.getOlPWDENT == null) {
        return false;
      }
      eventBus.$emit("openSpin", true); // emit the event to the bus
      const data = {
        oldPassword: context.getters.getOlPWDENT,
        newPassword: payload.newPassword,
        repeatPassword: payload.repeatPassword
      };
      const intercept = localStorage.getItem("token");
      apiServices.customizeHeader(intercept);
      apiServices.interceptionRoute(intercept);
      const decode = jwtDecode(intercept);
      apiServices
        .createNewPwd(data, decode.CA)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200) {
              //context.commit("SET_CONFIRM_TRANSFER_WALLET_CLIENTS", value);
            } else {
              let payload = {
                color: "error",
                text: "Ups! Verifique as suas credenciais",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center"
          };
          if (error == "Error: Network Error")
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center"
            }); // emit the event to the bus

          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },
    deleteEnterprise(context, payload) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      apiServices
        .dropEntity(payload)
        .then(function(response) {
          if (response.status === 200) {
            localStorage.removeItem("token");
            localStorage.removeItem("platform");
            localStorage.removeItem("myRef");
            localStorage.removeItem("Mopt");
            localStorage.removeItem("userString");
            window.location.replace("https://kyamipay.ao");
            // router.push("/").catch(() => {
            //   //throw new Error("Problem - Contact Sys factory");
            // });
          } else {
            let payload = {
              color: "error",
              text:
                "Seu pedido não foi processado. Verifique se há saldo na sua carteira",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center"
          };
          if (error == "Error: Network Error")
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center"
            }); // emit the event to the bus

          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },

    updateAndCreateEPin(context, pwd) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      apiServices
        .requestUpdateAndCreateEPin(pwd)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (
              obj.code === 200 &&
              obj.message === "creating" &&
              obj.type === "success"
            ) {
              eventBus.$emit("openModalUpdatePin", true);
              let payload = {
                color: "success",
                text: "Foi enviado um e-mail com o código de confirmação!",
                errorLogin: true
              };

              eventBus.$emit("openInfo", payload); // emit the event to the bus
              return;
            }

            if (
              obj.code === 200 &&
              obj.message === "created" &&
              obj.type === "success"
            ) {
              let payload = {
                color: "success",
                text: "Evento de PIN realizado com sucesso!",
                errorLogin: true
              };

              eventBus.$emit("openInfo", payload); // emit the event to the bus
              eventBus.$emit("openModalUpdatePin", false);
              return;
            }
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center"
          };
          if (error == "Error: Network Error")
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center"
            }); // emit the event to the bus

          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    }
  },

  getters: {
    getOlPWDENT(state) {
      return state.oldPWDENT;
    }
  }
};
